import React, { useContext } from 'react';
import GDPRModal from './GDPR/GDPRModal';
import AppLink from '../links/AppLink';
import styles from './Top.module.less';
import AccountContext from '../../services/AccountContext';

export default function Top() {
  const { isPremium } = useContext(AccountContext);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageWidth}>
        <div className={styles.content}>
          <div className={styles.column}>
            <h3 className={styles.heading}>Educational Tools</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <AppLink href="/resources/" className={styles.text}>
                  Learning Library
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink href="/worksheets/" className={styles.text}>
                  Worksheets
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink href="/games/" className={styles.text}>
                  Games
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink
                  href="/interactive-worksheets-overview/"
                  className={styles.text}
                >
                  Interactive Worksheets
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <a href="/worksheet-generator/" className={styles.text}>
                  Worksheet Generator
                </a>
              </li>
              <li className={styles.listItem}>
                <AppLink href="/lesson-plans/" className={styles.text}>
                  Lesson Plans
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <a href="/common-core/" className={styles.text}>
                  Common Core Resources
                </a>
              </li>
              {isPremium && (
                <li className={styles.listItem}>
                  <a href="/guided-lessons-overview/" className={styles.text}>
                    Guided Lessons
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>Support</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a
                  href="https://support.education.com/"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Help center
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/pricing/" className={styles.text}>
                  Pricing
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/school-accounts/" className={styles.text}>
                  Education.com For Schools
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/request-quote/" className={styles.text}>
                  Get a Quote
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/gift/" className={styles.text}>
                  Give Gift
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/gift/redeem/" className={styles.text}>
                  Redeem Gift
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/support/contact/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.text}
                >
                  Contact Us
                </a>
              </li>
              <li className={styles.listItem}>
                <GDPRModal />
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>Connect</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a
                  href="https://blog.education.com"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="http://www.ixl.com/feedback/educationdotcom"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Tell us what you think
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>About</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a href="/about/" className={styles.text}>
                  Company
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="https://www.ixl.com/company/careers"
                  className={styles.text}
                >
                  Careers
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/about/press/" className={styles.text}>
                  Press
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/reviews/" className={styles.text}>
                  Reviews
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/privacy/" className={styles.text}>
                  Privacy Policy
                </a>
              </li>
              <li className={styles.listItem}>
                <strong>
                  <a href="/privacy/child-privacy/" className={styles.text}>
                    COPPA Privacy Policy
                  </a>
                </strong>
              </li>
              <li className={styles.listItem}>
                <a href="/terms-of-use/" className={styles.text}>
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
